import { Stack } from '@mui/material';
import { ColorLabel } from '../../../../services/entities/impl/blfApi/schemas/stage';
import { ColorSetIcon } from './ColorSetIcon';

type Props = {
  colorSets: ColorLabel[][];
};

export const ColorSetDisplay = ({ colorSets }: Props) => {
  return (
    <Stack direction='row'>
      {colorSets.map((colorSet) => (
        <ColorSetIcon key={JSON.stringify(colorSet)} colors={colorSet} />
      ))}
    </Stack>
  );
};
